/* 

Copyright© Celligence International, LLC - 2025

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs list of misc payees currently active in system
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { fetchMiscPayees } from '../queryFunctions';

const useMiscPayees = (id: string, token: string) => {
  return useQuery({
    queryKey: [id, token],
    queryFn: ({ signal }: QueryFunctionContext) => fetchMiscPayees(signal, token),
    refetchOnWindowFocus: false,
  });
};

export default useMiscPayees;
